<template>
  <div>
    <b-card
      :img-src="image_source"
      img-alt="Image"
      img-top
      :class="card_classes"
      @click="home_card_click"
    >
      <div v-if="out_of_stock" id="stock_badge" class="w-100 bg-light text-center text-danger">Out of stock</div>

      <div class="card-body-container">
        <b-card-title>
          {{ title }}
          <p v-if="price != null" class="float-right font-lighter">{{ `$${price}` }}</p>
        </b-card-title>

        <b-card-text
          v-if="description != '...' && description != ''"
          class="font-lighter"
        >
          {{ description }}
        </b-card-text>

        <b-button
          @click="card_button_click"
          variant="primary"
          :class="button_classes"
        >
          {{ button_text }}
        </b-button>

        <b-link
          v-if="favourite_links"
          @click="favourite_button_click"
          :class="{'favourite-item': is_favourite}"
        >
          <font-awesome-icon v-if="is_favourite" icon="heart" />
          <font-awesome-icon v-else :icon="['far', 'heart']" />
        </b-link>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    object_id: String,
    title: String,
    description: String,
    image_source: String,
    card_classes: String,
    button_text: String,
    button_classes: String,
    favourite_links: Boolean,
    is_favourite: Boolean,
    price: String,
    out_of_stock: Boolean,
  },

  methods: {
    home_card_click() {
      this.$emit('home_card_click', this.object_id, this.title);
    },
    card_button_click() {
      this.$emit('card_button_click', this.object_id, this.title);
    },
    favourite_button_click() {
      if(this.$store.getters.logged_in)
        this.$emit('favourite_button_click', this.object_id);
      else
        this.$notify({
          type: 'error',
          text: 'You need to Login/Sign Up to use this feature.'
        })
    }
  }
}
</script>

<style scoped>
  .menu-item-card .card-body {
    padding: 10px;
  }
  .home-card {
    transition: transform 0.5s;
    cursor: pointer;
  }
  img {
    width: 100%;
    height: 200px;
    object-fit: cover;
  }
  .home-card:after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: opacity 2s cubic-bezier(0.165, 0.84, 0.44, 1);
    box-shadow: 0 8px 17px 0 rgba(0, 0, 0, .2), 0 6px 20px 0 rgba(0, 0, 0, .15);
    content: '';
    opacity: 0;
    z-index: -1;
  }
  .home-card:hover,
  .home-card:focus {
	  transform: scale3d(1.006, 1.006, 1);
  }
  .home-card:hover:after,
  .home-card:focus:after {
	  opacity: 1;
  }
  .menu-item-card:before,
  .menu-item-card:after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition: opacity 0.38s ease-in-out, transform 0.35s ease-in-out;
    content: '';
    opacity: 0;
    pointer-events: none;
  }
  .menu-item-card:before {
    transform: scale3d(0, 1, 1);
    transform-origin: left top;
    border-top: 1px solid #acacac;
    border-bottom: 1px solid #acacac;
  }
  .menu-item-card:after {
    transform: scale3d(1, 0, 1);
    transform-origin: right top;
    border-right: 1px solid #acacac;
    border-left: 1px solid #acacac;
  }
  .menu-item-card:hover:before,
  .menu-item-card:focus:before,
  .menu-item-card:hover:after,
  .menu-item-card:focus:after {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }
  .font-lighter {
    font-weight: lighter;
  }
  .menu-item-card .card-body {
    text-align: left;
  }
  .menu-item-card svg {
    margin: 7px;
    float: right;
  }
  .menu-item-card .btn {
    padding-left: 0;
  }
  .favourite-item {
    color: red;
  }
  .favourite-item:hover {
    color: rgb(255, 98, 98);
  }
  .menu-item-card.disable-card img {
    pointer-events: none;
    opacity: 0.5;
  }
  .menu-item-card.disable-card .card-body-container {
    pointer-events: none;
    opacity: 0.5;
  }
</style>
